<template>
    <div data-testid="system-releases">
        <p>
            This tab is deprecated. Releases are handled via GitHub Actions.
        </p>
        <p>
            This tab is only retained to prove AngularJS to Vue migration.
        </p>
    </div>
</template>
